import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Label, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import moment from 'moment';
import { useLocation } from 'react-router';
import { getTransaction, getTransactionDetails } from '../../store/transactionSlice';

const TransactionDetailsTable = () => {
  const storeVar = useSelector(state => state.transactions)
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    dispatch(getTransactionDetails(id))
  }, []);


  const getDateTime = (date) => {
    if (date) {
      return moment(date).format('HH:MM DD/MM/YYYY')
    }
  }

  const renderPriceDetails = (price) => {
    const base = Number(price) || 0;
    const gst = base * 0.18;
    const total = base + gst;
    const fmt = (val) => new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(val);
    return (
      <span style={{ fontSize: 13, color: '#2c3e50', fontWeight: 600 }}>
        ₹{fmt(total)} <span style={{ fontSize: 11, color: '#7f8c8d', fontWeight: 400, marginLeft: 8 }}>(Base: ₹{fmt(base)} + GST 18%: ₹{fmt(gst)})</span>
      </span>
    );
  };

  const getSummaryDetails = () => {
    const totalAmount = storeVar?.transactionDetails?.result?.amount || 0;
    // Since the processed payment total includes GST, we backtrack from it:
    const baseAmount = totalAmount / 1.18;
    const gstAmount = totalAmount - baseAmount;
    return { baseAmount, gstAmount, totalAmount };
  };

  const summary = getSummaryDetails();

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Col md={"12"} className='d-flex align-items-center justify-content-center'>
              <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">User Details</span>
            </Col>
            <Row>
              <Col md="4">
                <Label className="col-form-label" htmlFor="recipient-name">Name: {storeVar?.transactionDetails?.result?.userId.name || 'Guest'}</Label>
              </Col>
              <Col md="4">
                <Label className="col-form-label" htmlFor="recipient-name">Email: {storeVar?.transactionDetails?.result?.userId.email || ''} </Label>
              </Col>
              <Col md="4" className='items-center'>
                <Label className="col-form-label" htmlFor="recipient-name">Phone Number: {storeVar?.transactionDetails?.result?.userId.phoneNumber || ''}</Label>
              </Col>
              <Col md="4">
                <Label className="col-form-label" htmlFor="recipient-name">Transaction Id: {storeVar?.transactionDetails?.result?.transactionId || ''} </Label>
              </Col>
              <Col md="4" className='items-center'>
                <Label className="col-form-label" htmlFor="recipient-name">Phone Number: {storeVar?.transactionDetails?.result?.userId.phoneNumber || ''}</Label>
              </Col>
              <Col md="4" className='items-center'>
                <Label className="col-form-label" htmlFor="recipient-name">
                  Base Amount (Excl. GST): ₹{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(summary.baseAmount)}
                </Label>
              </Col>
              <Col md="4" className='items-center'>
                <Label className="col-form-label" htmlFor="recipient-name">
                  GST (18%): ₹{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(summary.gstAmount)}
                </Label>
              </Col>
              <Col md="4" className='items-center'>
                <Label className="col-form-label" htmlFor="recipient-name" style={{ fontWeight: 700, color: '#2c3e50' }}>
                  Total Amount Paid: ₹{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(summary.totalAmount)}
                </Label>
              </Col>
            </Row>
          </CardHeader>
          {storeVar?.transactionDetails?.mockTest?.length > 0 &&
            <CardHeader>
              <Col md={"12"} className='d-flex align-items-center justify-content-center'>
                <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">Mock Test</span>
              </Col>
              {storeVar?.transactionDetails?.mockTest && storeVar?.transactionDetails?.mockTest.map((item, index) => (
                <Row key={index}>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {item.mockTestId.title}</Label>
                  </Col>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {renderPriceDetails(item.mockTestId.price)}</Label>
                  </Col>
                </Row>
              ))}
            </CardHeader>
          }
          {storeVar?.transactionDetails?.pyqTest?.length > 0 &&
            <CardHeader>
              <Col md={"12"} className='d-flex align-items-center justify-content-center'>
                <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">Previous Year Paper</span>
              </Col>
              {storeVar?.transactionDetails?.pyqTest.map((item, index) => (
                <Row key={index}>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {item.pyqId.title}</Label>
                  </Col>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {renderPriceDetails(item.pyqId.price)}</Label>
                  </Col>
                </Row>
              ))}
            </CardHeader>
          }
          {storeVar?.transactionDetails?.recordedClass?.length > 0 &&
            <CardHeader>
              <Col md={"12"} className='d-flex align-items-center justify-content-center'>
                <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">Recorded Class</span>
              </Col>
              {storeVar?.transactionDetails?.recordedClass.map((item, index) => (
                <Row key={index}>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {item.recordedClassId.title}</Label>
                  </Col>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {renderPriceDetails(item.recordedClassId.videoPrice)}</Label>
                  </Col>
                </Row>
              ))}
            </CardHeader>
          }
          {storeVar?.transactionDetails?.recordedClassTest?.length > 0 &&
            <CardHeader>
              <Col md={"12"} className='d-flex align-items-center justify-content-center'>
                <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">Recorded Class Question</span>
              </Col>
              {storeVar?.transactionDetails?.recordedClassTest.map((item, index) => (
                <Row key={index}>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {item.recordedClassId.title}</Label>
                  </Col>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {renderPriceDetails(item.recordedClassId.testPrice)}</Label>
                  </Col>
                </Row>
              ))}
            </CardHeader>
          }
          {storeVar?.transactionDetails?.liveClass?.length > 0 &&
            <CardHeader>
              <Col md={"12"} className='d-flex align-items-center justify-content-center'>
                <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">Live Class</span>
              </Col>
              {storeVar?.transactionDetails?.liveClass.map((item, index) => (
                <Row key={index}>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {item.liveClassId.title}</Label>
                  </Col>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {renderPriceDetails(item.liveClassId.livePrice)}</Label>
                  </Col>
                </Row>
              ))}
            </CardHeader>
          }
          {storeVar?.transactionDetails?.liveClassTest?.length > 0 &&
            <CardHeader>
              <Col md={"12"} className='d-flex align-items-center justify-content-center'>
                <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">Live Class Questions</span>
              </Col>
              {storeVar?.transactionDetails?.liveClassTest.map((item, index) => (
                <Row key={index}>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {item.liveClassId.title}</Label>
                  </Col>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {renderPriceDetails(item.liveClassId.examPrice)}</Label>
                  </Col>
                </Row>
              ))}
            </CardHeader>
          }
          {storeVar?.transactionDetails?.enoteCart?.length > 0 &&
            <CardHeader>
              <Col md={"12"} className='d-flex align-items-center justify-content-center'>
                <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">Enote</span>
              </Col>
              {storeVar?.transactionDetails?.enoteCart.map((item, index) => (
                <Row key={index}>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {item.enoteChapterId.title}</Label>
                  </Col>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {renderPriceDetails(item.enoteChapterId.price)}</Label>
                  </Col>
                </Row>
              ))}
            </CardHeader>
          }
          {storeVar?.transactionDetails?.bodmasTestSeries?.length > 0 &&
            <CardHeader>
              <Col md={"12"} className='d-flex align-items-center justify-content-center'>
                <span className="col-form-label f-w-600 f-20" htmlFor="recipient-name">BODMAS Test Series</span>
              </Col>
              {storeVar?.transactionDetails?.bodmasTestSeries.map((item, index) => (
                <Row key={index}>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {item.testSeriesId?.title || 'Test Series'}</Label>
                  </Col>
                  <Col md="6">
                    <Label className="col-form-label" htmlFor="recipient-name"> {renderPriceDetails(item.testSeriesId?.price)}</Label>
                  </Col>
                </Row>
              ))}
            </CardHeader>
          }




        </Card>
      </Col>
    </Fragment>
  );
};

export default TransactionDetailsTable;
